<template>
  <div :class="show ? 'home-right show' : 'home-right'" @click.stop="">
    <div class="btns-wrap">
      <div v-if="menuTypes!=='selectionInquiry'">

      </div>
      <div class="btns">
        <!-- 选型分类 -->
        <template v-if="menuTypes==='selectionInquiry'">
          <div class="goCart" @click="goCart()">
            <i class="el-icon-shopping-cart-2"></i>
            <span>购物车</span>
          </div>
        </template>

        <template v-else>
          <div @click="() => toPath('/sparePartsLibrary')">备件库存</div>
          <div @click="onShowList">领用车</div>
          <div @click="() => toPath('/spareGetList')">备件领用</div>
          <div class="dt-up" @click="jump('a0')">
            <img src="~@/assets/img/up.jpg" alt="向上" />
          </div>
        </template>
      </div>
    </div>
    <div class="tab-content">
      <div class="tab">
        <div
          class="tab-btn"
          @click="() => changeType(4)"
          :class="{ active: type === 4 }"
        >
          领用车
        </div>
        <div
          class="tab-btn"
          @click="() => changeType(1)"
          :class="{ active: type === 1 }"
        >
          购物车
        </div>
        <div class="close-btn">
          <i @click="show = false" class="el-icon-close"></i>
        </div>
      </div>
      <div class="content-area">
        <NoData v-if="dataList.length === 0" />
        <List :dataList="dataList" :type="type" v-else @change="getList" />
      </div>
      <div class="submit-area">
        <div class="submit-left">
          <span class="num">{{ goodsNumTotal }}</span> 件{{
            type === 4 ? "备件" : "商品"
          }}
          <div>
            共计：
            <span class="price" v-if="type === 1">{{ priceTotal | formatePrice }}</span>
            <span class="price" v-if="type === 4">{{ priceTotal | formatePrice4 }}</span>
          </div>
        </div>
        <div class="submit-right">
          <div
            class="submit-btn"
            @click="() => toPath(`/myShopCart?activited=${type}`)"
          >
            去{{ type === 4 ? "领用车" : "购物车" }}结算
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from './noData.vue'
import List from './list.vue'
import { mul, add } from '@/utils/numberComputed'
import { scrollIntoView } from '@/utils'
export default {
  data () {
    return {
      show: false,
      type: 4, // 领用车1还是购物车4
      dataList: [], // 数据
      goodsNumTotal: 0, // 数量
      priceTotal: 0,
      selectionInquiryList: [
        'selectionCategoryList',
        'selectionInquiryDetail',
        'selectionInquiryCreate',
        'sceneSelectionHome',
        'sceneSelectionScene'
      ]
    }
  },
  components: {
    NoData,
    List
  },
  watch: {
    dataList () {
      let goodsNumTotal = 0
      let priceTotal = 0
      this.dataList.forEach((v) => {
        goodsNumTotal = add(v.goodsNum, goodsNumTotal)
        priceTotal = add(mul(v.sellingPrice, v.goodsNum), priceTotal)
      })
      this.goodsNumTotal = goodsNumTotal
      this.priceTotal = priceTotal
    }
  },
  created () {
    this.getList()
  },
  computed: {
    menuTypes () {
      let result = ''
      if (this.selectionInquiryList.includes(this.$route.name)) {
        result = 'selectionInquiry'
      }
      return result
    }
  },
  methods: {
    onShowList () {
      this.show = !this.show
      this.changeType(4)
    },
    toPath (path) {
      this.$router.push({
        path
      })
    },
    changeType (type) {
      this.type = type
      this.getList()
    },
    getList () {
      this.$http
        .get(`/front/consumer/shoppingcart/myShoppingCartList/${this.type}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          this.dataList = res.data.available || []
        })
    },
    jump (domId) {
      let height =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let num = (Number(domId.slice(1)) || 0) - 4
      if (num >= 0) {
        // 自定义楼层
        scrollIntoView(this.$refs.homeRefs[num], 0)
      } else {
        if (num === -4) {
          // 返回顶部
          this.height = -height
          scrollIntoView(document.body, 0)
        } else {
          // 固定楼层 1，2，3
          scrollIntoView(this.$refs[domId], 0)
        }
      }
    },
    goCart () {
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        this.$router.push({
          name: "corpWebsite-myShopCart",
        });
      } else {
        this.$router.push({
          name: "myShopCart",
          query: {
            activited: '6'
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-right {
  position: fixed;
  display: flex;
  height: 100vh;
  z-index: 101;
  top: 0;
  right: 16px;
  pointer-events: none;

  &.show {
    .tab-content {
      width: 383px;
    }
  }
  .btns-wrap {
    display: flex;
    align-items: center;
  }
  .btns {
    pointer-events: auto;
    width: 50px;
    border-radius: 6px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.17);
    > div {
      position: relative;
      padding: 5px;
      font-size: 14px;
      color: #3d88d4;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      background: #ffffff;
      &.active,
      &:hover {
        background: #3d88d4;
        color: #fff;
        &::before {
          border-color: #3d88d4;
        }
      }
      &.dt-up:hover {
        background: #fff;
        &::before {
          border-color: #f2f2f2;
        }
      }
      &::before {
        position: absolute;
        top: 0;
        display: block;
        content: " ";
        width: 40px;
        height: 1px;
        border-top: 1px solid #f2f2f2;
      }
      &:first-child::before {
        border: none;
      }
      &.goCart{
        width: 50px;
        height: 54px;
        background: #1767A9;
        border-radius: 8px 0px 0px 8px;
        color: #fff;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        >i{
          font-size: 14px;
        }
      }
    }
  }

  .tab {
    display: flex;
    align-items: center;
    width: 383px;
    height: 63px;
    background: #ffffff;
    padding: 0 20px;
    .tab-btn {
      margin: 0 16px;
      font-size: 16px;
      color: #999999;
      cursor: pointer;
      line-height: 61px;
      border-bottom: 2px solid transparent;
      &.active,
      &:hover {
        color: #333;
        border-color: #1d65a8;
      }
    }
    .close-btn {
      flex: 1;
      text-align: right;
      i {
        font-size: 16px;
        color: #3d88d4;
        cursor: pointer;
      }
    }
  }
  .tab-content {
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    width: 0;
    height: 100%;
    background: #efefef;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.17);
    transition: all 0.3s;
    overflow: hidden;
    .content-area {
      flex: 1;
      overflow: auto;
    }
    .submit-area {
      display: flex;
      height: 70px;
      padding: 12px 31px 12px 12px;
      background: #ffffff;
      .submit-left {
        font-size: 12px;
        color: #999;
        line-height: 20px;
        .num {
          color: #333;
        }
        .price {
          &::before {
            content: "¥";
            font-size: 12px;
          }
          color: #f62f18;
        }
      }
      .submit-right {
        display: flex;
        align-items: center;
        justify-content: right;
        flex: 1;
        .submit-btn {
          width: 112px;
          background: #3d88d4;
          border-radius: 4px;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
  }
}
</style>
